import { useQuery } from '@northladder/services';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';

/**
 * This key is used to track useTransferFilterListQuery
 */
const TRANSFER_FILTER_QUERY_KEY = 'transfer-filter-query-key';

/**
 * This hook fetches the transfer list.
 */
export const useTransferFilterListQuery = (enabled: boolean) => {
  const { data, error, isError, isFetching, isPending, refetch } = useQuery({
    enabled,
    queryKey: [TRANSFER_FILTER_QUERY_KEY],
    networkMode: 'always',
    retry: false,
    queryFn: INV_MGMT_SERVICE_API.getTransferFilters,
  });

  return {
    data,
    error,
    isError,
    isFetching,
    isPending,
    refetch,
  };
};
